import { changeOpacity } from 'utils/styles'

import defaults from './color/defaults'
import ecuColors from './color/ecus'
import ModalColors from './color/checGenenicModal'
import ecpColletColors from './color/ecps'
import ptoColors from './color/pto'
import dimensions from './dimensions'

const setcolor = {
  defaults,
}

const setTheme = (themeName) => {
  const themeChoice = themeName || 'defaults'
  const palette = setcolor[themeChoice] || defaults

  const themeDefs = {
    /** Font Family XXX remove from Alert, remove here */
    fontFamily: 'Arial',

    navLinkActiveBorder: palette.daimlerPrimary,
    navBorderBottomColor: palette.grey,
    navTextUnselectedColor: palette.slatePrimary,
    harnessTabUnselectedColor: palette.slateLight,
    harnessTabsBorderBottom: palette.grey,

    /** Paragraph */
    paragraphColor: palette.blackSecondary,
    paragraphErrorColor: palette.errorPrimary,
    paragraphContrastColor: palette.whitePrimary,

    /** Header */
    headerColor: palette.blackPrimary,
    headerColorWhite: palette.whitePrimary,

    /** Link */
    linkDarkColor: palette.bluePrimary,
    linkColor: palette.blueSecondary,
    linkHoverColor: palette.blueAccent,
    iconLinkColor: palette.greyPrimary,
    iconLinkHover: palette.bluePrimary,

    /** Error Boundary */
    errorBoundaryBgColor: palette.whitePrimary,
    errorBoundaryHeaderColor: palette.blackPrimary,
    errorBoundaryIconColor: palette.blackPrimary,

    /** Tables and Basic Boxes */
    basicBoxBackgroundColor: palette.whitePrimary,
    basicBoxBorderColor: palette.grey,
    hoverBoxColor: palette.blueLight,
    rowHighlightColor: palette.blueAvailable,
    errorBoxBackgroundColor: changeOpacity(palette.warningPrimary, 0.2),

    /** Button Primary */
    // TODO: rename to btnPrimaryColor for consistency
    buttonPrimaryColor: palette.whitePrimary,
    btnPrimaryBg: palette.bluePrimary,
    btnPrimaryBorderColor: palette.bluePrimary,
    btnPrimaryHoverColor: palette.blueAccent,
    btnPrimaryHoverLightColor: ModalColors.denimBlue,
    btnPrimaryHoverBg: palette.blueAccent,
    btnPrimaryHoverBorderColor: palette.blueAccent,
    btnPrimaryFocusColor: palette.blueSecondary,
    btnPrimaryFocusBg: palette.blueSecondary,
    btnPrimaryFocusBorderColor: palette.blueSecondary,
    btnPrimaryActiveFocusColor: ModalColors.curiousBlue,

    /** Button Secondary */
    btnSecondaryColor: palette.bluePrimary,
    btnSecondaryBg: palette.whitePrimary,
    btnSecondaryBorderColor: palette.bluePrimary,
    btnSecondaryHoverColor: palette.blueAccent,
    btnSecondaryHoverBg: palette.whitePrimary,
    btnSecondaryHoverBorderColor: palette.blueSecondary,
    btnSecondaryFocusColor: palette.blueSecondary,
    btnSecondaryFocusBg: palette.whitePrimary,
    btnSecondaryFocusBorderColor: palette.blueSecondary,

    btnTertiaryColor: palette.blackSecondary,
    btnTertiaryHoverColor: palette.errorPrimary,

    /** Button Icon */
    btnIconColor: palette.slateLight,
    btnIconHoverBg: changeOpacity(palette.black, 0.07),

    /** Button On Color Light */
    btnOnColorLightColor: palette.whitePrimary,
    btnOnColorLightBorderColor: palette.whitePrimary,
    btnOnColorLightHoverColor: palette.whiteSecondary,
    btnOnColorLightHoverBorderColor: palette.whiteSecondary,
    btnOnColorLightFocusColor: palette.whiteSecondary,
    btnOnColorLightFocusBorderColor: palette.whiteSecondary,

    /** Button On Color Dark */
    btnOnColorDarkColor: palette.blackSecondary,
    btnOnColorDarkBorderColor: palette.blackSecondary,
    btnOnColorDarkHoverColor: palette.greyPrimary,
    btnOnColorDarkHoverBorderColor: palette.greyPrimary,
    btnOnColorDarkFocusColor: palette.greyPrimary,
    btnOnColorDarkFocusBorderColor: palette.greyPrimary,

    /** Button Danger */
    btnDangerColor: palette.errorSecondary,
    btnDangerBg: palette.greySecondary,
    btnDangerBorderColor: palette.slateDisabled,
    btnDangerHoverColor: palette.whitePrimary,
    btnDangerHoverBg: palette.errorPrimary,
    btnDangerHoverBorderColor: palette.errorPrimary,
    btnDangerFocusColor: palette.whitePrimary,
    btnDangerFocusBg: palette.errorSecondary,
    btnDangerFocusBorderColor: palette.errorSecondary,

    /** Button Disabled */
    btnDisabledColor: palette.slateDisabled,
    btnDisabledBg: palette.greySecondary,
    btnDisabledBorderColor: palette.grey,
    primaryButtonDisable: ModalColors.whiteSmoke,
    primaryButtonDisableBorder: ModalColors.grayDisableBorder,
    primaryButtonDisableBlackShade: ModalColors.grayDisableBorder,

    /** Switch button */
    switchTrueBackgroundColor: palette.confirmAccent,
    switchFontColor: palette.blackSecondary,

    /** link button */
    btnLinkColor: palette.blueSecondary,

    /** icon button */
    clearFiltersBtnIconColor: palette.blueAccent,
    iconColor: palette.greySecondary,
    iconHoverColor: palette.blueAvailable,

    /** Bullet Radio Button Group */
    radioButtonGroupBulletTextColor: palette.blackSecondary,
    radioButtonGroupBulletBorderColor: palette.slateDisabled,
    radioButtonGroupBulletSelectedColor: palette.blueSecondary,
    radioButtonGroupBulletSelectedBorderColor: palette.blueAccent,
    radioButtonGroupBulletColor: palette.blueSecondary,
    radioButtonGroupBulletHoverColor: palette.blueSecondary, // UX sez no effect here
    radioButtonGroupBulletHoverBorderColor: palette.blueAccent,
    radioButtonGroupBulletDisabledTextColor: palette.greyPrimary,
    radioButtonGroupBulletDisabledColor: palette.slateDisabled,
    radioButtonGroupBulletDisabledBackgroundColor: palette.greySecondary,
    radioButtonGroupBulletDisabledBorderColor: palette.grey,

    /** Radio Button Group (Button UI for Radio inputs) */
    radioButtonGroupColor: palette.bluePrimary,
    radioButtonGroupBg: palette.whitePrimary,
    radioButtonGroupBorderColor: palette.slateDisabled,
    radioButtonGroupHoverColor: palette.blueAccent,
    radioButtonGroupHoverBg: palette.whitePrimary,
    radioButtonGroupHoverBorderColor: palette.slateDisabled,
    radioButtonGroupFocusColor: palette.bluePrimary,
    radioButtonGroupFocusBg: palette.whitePrimary,
    radioButtonGroupFocusBorderColor: palette.bluePrimary,
    radioButtonGroupDisabledColor: palette.slateDisabled,
    radioButtonGroupDisabledBg: palette.greySecondary,
    radioButtonGroupDisabledBorderColor: palette.slateDisabled,
    radioButtonGroupSelectedColor: palette.whitePrimary,
    radioButtonGroupSelectedBg: palette.blueSecondary,
    radioButtonGroupSelectedBorderColor: palette.blueSecondary,
    radioButtonColor: palette.slateLight,
    radioButtonTextColor: palette.blackSecondary,
    radioButtonDisabledBorder: palette.grey,
    radioButtonDisabledTextColor: palette.greyPrimary,

    /** Alerts */
    alertSuccessBgColor: palette.confirmPrimary,
    alertSuccessColor: palette.whitePrimary,
    alertInfoBgColor: palette.blueSecondary,
    alertInfoColor: palette.whitePrimary,
    alertWarningBgColor: palette.warningPrimary,
    alertWarningColor: palette.blackSecondary,
    alertErrorBgColor: palette.errorPrimary,
    alertErrorColor: palette.whitePrimary,
    alertButtonHoverBgColor: palette.whitePrimary,
    alertButtonHoverColor: palette.blackSecondary,
    alertMessageInfoIconColor: palette.errorPrimary,

    /** Toast Alerts */
    toastColor: palette.blackSecondary,
    toastIconColor: palette.whitePrimary,
    toastSuccessBgColor: palette.confirmAccent,
    toastInfoBgColor: palette.blueAccent,
    toastWarningBgColor: palette.warningAccent,
    toastErrorBgColor: palette.errorAccent,
    toastBackground: palette.whitePrimary,

    /** Radio Button */
    radioButtonMainColor: palette.blueSecondary,
    radioButtonHoverColor: palette.blueAccent,
    radioButtonDisabledMainColor: palette.greySecondary,

    /** Badge */
    badgeDefaultColor: palette.blackSecondary,
    badgeWarningColor: palette.warningAccent,
    badgeDefaultTextColor: palette.whitePrimary,
    badgeWarningTextColor: palette.blackSecondary,
    badgeTrueBackground: palette.confirmAccent,
    badgeFalseBackground: palette.slateLight,
    badgeBorderColor: palette.whitePrimary,

    /** Input */
    // XXX remove all but label size, footer
    inputLargeFontSize: '16px',
    inputLargeLabelFontSize: '14px',
    inputLargeLineHt: '1.38',
    inputLargeFooterAlign: 'left',

    inputDefaultFontSize: '14px',
    inputDefaultLabelFontSize: '12px',
    inputDefaultLineHt: '1.29',
    inputDefaultFooterAlign: 'left',
    inputDefaultHeight: '32px',

    inputSmallFontSize: '12px',
    inputSmallLabelFontSize: '12px',
    inputSmallLineHt: '1.5',
    inputSmallFooterAlign: 'left',

    inputBorderColor: palette.slateDisabled,
    inputBorderErrorColor: palette.errorPrimary,
    inputBorderHoverColor: palette.blueAccent,
    inputBorderDisabledColor: palette.grey,
    inputBorderErrorFocusColor: palette.errorAccent,
    inputBorderFocusColor: palette.blueSecondary,
    inputBorderFocusAccentColor: palette.blueAccent,
    inputBgColor: palette.whitePrimary,
    inputBgDisabledColor: palette.greySecondary,
    inputFooterErrorColor: palette.errorPrimary,
    inputPlaceholderColor: palette.greyPrimary,
    inputFontColor: palette.blackSecondary,
    inputFontSecondaryColor: palette.greyPrimary,
    inputFontDisabledColor: palette.greyPrimary,
    suffixFontColor: palette.greyPrimary,
    prefixFontColor: palette.greyPrimary,
    inputRequiredWarning: palette.warningPrimary,

    /* Selectable SVGs */
    selectableElementBgColor: palette.blueAvailable,
    selectableElementTextColor: palette.blackPrimary,
    selectableElementHoverBgColor: palette.blueAccent,

    selectedElementPathColor: palette.blackPrimary,
    selectedElementBgColor: palette.blueSecondary,
    selectedElementTextColor: palette.whitePrimary,

    availableElementFillColor: palette.blueAvailable,
    hoverableElementStrokeColor: palette.daimlerSecondary,
    hoverableElementFillColor: palette.daimlerSecondary,

    uneditableElementBgColor: palette.greySecondary,
    uneditableElementStrokeColor: palette.greyPrimary,
    disabledElementStrokeColor: palette.grey,
    disabledElementBgColor: palette.greySecondary,
    unavailableBorderColor: 'rgba(210, 212, 214,1)',

    interfaceConnectorBgColor: palette.grey,
    interfaceConnectorBandColor: palette.slateLight,
    interfaceConnectorBorderColor: palette.blackPrimary,
    interfaceConnectorTextColor: palette.whitePrimary,
    interfaceConnectorOuterBandBorderColor: palette.greyPrimary,
    interfaceOuterBorderColor: palette.blackSecondary,

    /** new/unsorted  ... */
    inputMaskingCharColor: palette.slateSecondary,
    dropdownFooterColor: palette.greySecondary,
    functionGraphConnectorColor: palette.slateSecondary,

    vehicleBackroundColor: palette.grey,
    vehicleSpaceAvaliableColor: palette.confirmAccent,
    vehicleNearlyFullColor: palette.warningPrimary,
    vehicleFullColor: palette.errorPrimary,
    hoverPrimaryColor: palette.blueAccent,
    selectedPrimaryColor: palette.blueSecondary,
    borderPrimary: palette.slateLight,

    /** Steps component */
    activeStepIconBackground: palette.blueAccent,
    activeStepIconColor: palette.whitePrimary,
    activeStepTextColor: palette.blackPrimary,
    finishedStepIconText: palette.blueSecondary,
    /** AddRPCollection component */
    addRPCollectionHeader: palette.blackPrimary,
    /** Tabs component */
    inactiveTabTextColor: palette.black,
    activeTabBackground: palette.daimlerPrimary,

    pillBackgroundColor: palette.blueSecondary,
    pillColor: palette.whitePrimary,

    /** Loading component */
    loadingSpinnerFontColor: palette.blackPrimary,

    /** Feature */
    featureLogicSetBackgroundColor: palette.offWhite,
    featureLogicSetBackgoundSelectedColor: palette.blueAvailable,
    featureSubQueryBackgroundColor: palette.grey,
    featureSubQueryBackgoundSelectedColor: palette.blueAvailable,
    featureBorderWarningColor: palette.warningPrimary,
    featureBorderSelectedColor: palette.blueSecondary,
    featureBorderHoveredColor: palette.blueAccent,
    featureBorderColor: palette.slateLight,
    featureHeaderIconColor: palette.slateLight,
    featureConnectorLines: palette.slateSecondary,
    featureOutputTypeBackground: palette.greySecondary,
    featureOutputTypeBackgroundSelected: palette.whitePrimary,
    featureGatesDefault: palette.slateSecondary,
    featureGatesSelectedColor: palette.blueSecondary,

    /** Feature Orphan Nodes Column */
    featureOrphanColBackground: palette.greySecondary,
    featureOrphanColBoarderColor: palette.solidGrey,

    featureTimerInfoHighlight: palette.greySecondary,

    /** Feature Simulation */
    featureSimulatedValueResetIcon: palette.blueSecondary,
    featureSimulatedValueResetIconHover: palette.blueAccent,

    /** Rung */
    rungActiveBackgroundColor: palette.blueSecondary,
    rungErrorBackgroundColor: palette.blackPrimary,
    rungValidBackgroundColor: palette.confirmAccent,

    /** slotCopy input indicator */
    slotCopyInputIndicatorColor: palette.greyPrimary,

    /** N Subconfig Enable/Disable indicator* */
    nSubconfigDisabledIndicatorColor: palette.solidGrey,
    nSubconfigEnabledIndicatorColor: palette.confirmPrimary,

    /** theme behavior colors */

    /** default */
    logicalSlotInputDefaultBackgroundColor: palette.grey,
    logicalSlotOutputDefaultBackgroundColor: palette.whitePrimary,
    logicalSlotOutputDefaultBorderColor: palette.grey,
    lineDefaultOpaqueColor: palette.solidGrey,
    textDefaultBackgroundColor: palette.whitePrimary,

    /** disabled */
    disabledTextColor: palette.greyPrimary,

    /** changed */
    activeElementTextColor: palette.black,
    activeIndicatorElementColor: palette.confirmAccent, // TODO: revise prop name?

    /** error */
    errorIndicatorElementColor: palette.errorPrimary,

    /** changed */
    changedElementBoxShadowColor: palette.shadow,
    changedElementBorderColor: palette.blueAccent,

    /** selected */
    selectedElementBoxShadowColor: palette.blueAccent,
    selectedElementBorderColor: palette.blueSecondary,
    selectedElementBackgroundColor: palette.blueAvailable,

    /** pageMeta */
    pageMetaPrimary: palette.bluePrimary,
    pageMetaSubHeader: palette.blackPrimary,

    /** Vehicle Summary Pane */
    vehicleSummaryPaneBackground: palette.greySecondary,

    /** Primary Navbar */
    primaryNavBackgroundColor: palette.daimlerPrimary,
    primaryNavChecLogoColor: palette.daimlerPrimary,
    primaryNavSupportItemColor: palette.whitePrimary,
    primaryNavSupportItemHoverColor: palette.whiteSecondary,
    primaryNavInfoIconHoverColor: palette.whitePrimary,
    primaryNavWebsiteIconHoverColor: palette.whitePrimary,
    primaryNavProfileNavItemBgColor: palette.whiteSecondary,
    primaryNavProfileNavItemTextColor: palette.daimlerPrimary,
    primaryNavProfileNavItemHoverColor: palette.daimlerPrimary,
    primaryNavProfileNavItemBgHoverColor: palette.whitePrimary,
    primaryNavProfileAlertTextColor: palette.blackPrimary,

    /** Primary Nav-Main Menu */
    primaryNavItemRightLinkHoverColor: palette.whitePrimary,
    primaryNavItemLeftLinkTextColor: palette.whitePrimary,
    primaryNavItemRightLinkTextColor: palette.whiteSecondary,
    primaryNavItemRightHoverColor: palette.daimlerAccentHover,
    primaryNavItemLeftSelectedColor: palette.daimlerAccentSelected,

    /** Primary Nav-Dropdown Menu */
    primaryNavItemMenuItemTextColor: palette.bluePrimary,
    primaryNavItemMenuItemTextHoverColor: palette.bluePrimary,
    primaryNavItemMenuItemTextHoverBgColor: palette.blueLight,
    primaryNavItemMenuLinkTextColor: palette.bluePrimary,
    primaryNavItemMenuLinkTextHoverColor: palette.bluePrimary,

    /** Footer */
    footerBgColor: palette.blackSecondary,
    footerSeparatorColor: palette.whiteSecondary,
    footerCopyrightTextColor: palette.whiteSecondary,
    footerServerInfoTextColor: palette.whiteSecondary,

    /** Icons */
    hoverIconColor: palette.blueAccent,
    drawerWideCaretColor: palette.blueAccent,
    inactiveIconColor: palette.blackSecondary,
    favoriteStarFill: palette.warningPrimary,
    warningModalIcon: ModalColors.lightningYellowIcon,

    /** Modals */
    modalBorderColor: palette.grey,
    modalHeaderColor: ModalColors.blackColor,
    modalHeaderBottomBorder: ModalColors.lightGray,
    antModal: ModalColors.blackColorLightShade,

    /** Drawer */
    drawerBorderColor: palette.grey,
    drawerTabIconColor: palette.blueSecondary,

    /** CTP Modal */
    ctpModalHeaderBackground: palette.warningPrimary,
    ctpAvailablePin: palette.confirmAccent,
    ctpModalCardTextColor: palette.slatePrimary,

    /** Switch and Gauge Drawer Table */
    sAndGTableHeaderFillColor: palette.grey,
    sAndGListHeaderIconBorderColor: palette.grey,
    sAndGTableHeaderBorderColor: palette.grey,

    /** Table colors */
    tableGrayBackground: palette.greySecondary,
    tableColor: palette.blackSecondary,
    tableBorder: palette.grey,
    tableWhiteBackground: palette.whitePrimary,
    tableCheckboxHover: palette.blueAccent,
    tableCheckboxChecked: palette.blueSecondary,
    tableCheckboxInner: palette.slateLight,

    /** S&G Show Part Numbers Switch */
    sAndGShowPartNumbersLabel: palette.whitePrimary,
    sAndGShowPartNumbersBackground: palette.blueSecondary,
    sAndGPartBorderSelected: palette.blueSecondary,
    sAndGPartBorderHover: palette.blueAccent,
    sAndGPartBorderaugeHasChanged: palette.blueSecondary,
    sAndGPartBorderSelectedAndHasChanged: palette.greySecondary,
    sAndGPartBorder: palette.black,

    /** S&G Part Number Overlay */
    sAndGPartNumberBackgroundColor: palette.blueLight,
    sAndGPartNumberBackgroundColorSelected: palette.daimlerPrimary,
    sAndGPartNumberBorderColor: palette.daimlerAccent,
    sAndGPartNumberColorSelected: palette.whitePrimary,
    sAndGCustomIconBackgroundSelected: palette.whitePrimary,
    sAndGCustomIconFontSelected: palette.blackSecondary,

    /** S&G Display All Locations Checkbox */
    sAndGDisplayAllLocationsBkgrd: palette.greySecondary,
    sAndGDisplayAllLocationsBorder: palette.grey,

    /** S&G Pill */
    sAndGPillMoved: palette.blueSecondary,
    sAndGPillRemoved: palette.errorPrimary,

    /** S&G Drawer */
    sAndGDrawerDivider: palette.grey,
    sAndGDrawerBackground: palette.whitePrimary,

    /** S&G Add Component  */
    sAndGDrawerAddComponentColor: palette.blueSecondary,

    /** S&G Remove Component */
    sAndGRemoveComponentOutline: palette.errorPrimary,

    /** S&G Sidebar Styles */
    sAndGGroupBoarderColor: palette.greySecondary,
    sAndGHasMovedBkgColor: palette.greySecondary,

    /** S&G Locations */
    sAndGDropLocationCanDropBoarderColor: palette.blueAccent,
    sAndGDropLocationBoarderColor: palette.whitePrimary,

    /** PTO diagram */
    diagramOutline: palette.slateDisabled,
    diagramLinePrimary: palette.slateSecondary,
    diagramLineSecondary: palette.grey,

    diagramBoxBackgroundPrimary: palette.grey,
    diagramBoxBackgroundPrimaryHover: palette.grey,
    diagramBoxBackgroundPrimarySelected: palette.blueAvailable,
    diagramBoxBackgroundPrimaryOutline: palette.slateDisabled,
    diagramBoxBackgroundPrimaryOutlineAlternate: palette.blueSecondary,

    diagramTextSecondary: palette.greyPrimary,

    solenoidControlEndFirstBackground: ptoColors.purple,
    solenoidControlEndFirstBackgroundHover: ptoColors.purpleLight,
    solenoidControlEndFirstBackgroundSelected: ptoColors.purpleDark,
    solenoidControlEndFirstBackgroundOutline: palette.blackSecondary,
    solenoidControlEndFirstBackgroundOutlineAlternate: ptoColors.purpleBlack,

    engagementCriteriaEndFirstBackground: ptoColors.orange,
    engagementCriteriaEndFirstBackgroundHover: ptoColors.orangeLight,
    engagementCriteriaEndFirstBackgroundSelected: ptoColors.orangeDark,
    engagementCriteriaEndFirstBackgroundOutline: palette.blackSecondary,
    engagementCriteriaEndFirstBackgroundOutlineAlternate: ptoColors.orangeBlack,

    powertrainLimitsDetroitBackground: ptoColors.green,
    powertrainLimitsDetroitBackgroundHover: ptoColors.greenLight,
    powertrainLimitsDetroitBackgroundSelected: ptoColors.greenDark,
    powertrainLimitsDetroitBackgroundOutline: palette.blackSecondary,
    powertrainLimitsDetroitBackgroundOutlineAlternate: ptoColors.greenBlack,

    ptoStatusBackground: ptoColors.blue,
    ptoStatusBackgroundHover: ptoColors.blueLight,
    ptoStatusBackgroundSelected: ptoColors.blueDark,
    ptoStatusBackgroundOutline: palette.blackSecondary,
    ptoStatusBackgroundOutlineAlternate: ptoColors.blueBlack,

    wescBackground: ptoColors.purpleDark,
    wescBackgroundOutline: ptoColors.purpleBlack,

    redBackground: ptoColors.red,
    redBackgroundHover: ptoColors.redLight,
    redBackgroundSelected: ptoColors.redDark,
    redBackgroundOutline: palette.blackSecondary,
    redBackgroundOutlineAlternate: ptoColors.redBlack,

    purpleBackground: ptoColors.purple,
    purpleBackgroundHover: ptoColors.purpleLight,
    purpleBackgroundSelected: ptoColors.purpleDark,
    purpleBackgroundOutline: palette.blackSecondary,
    purpleBackgroundOutlineAlternate: ptoColors.purpleBlack,

    orangeBackground: ptoColors.orange,
    orangeBackgroundHover: ptoColors.orangeLight,
    orangeBackgroundSelected: ptoColors.orangeDark,
    orangeBackgroundOutline: palette.blackSecondary,
    orangeBackgroundOutlineAlternate: ptoColors.orangeBlack,

    greenBackground: ptoColors.green,
    greenBackgroundHover: ptoColors.greenLight,
    greenBackgroundSelected: ptoColors.greenDark,
    greenBackgroundOutline: palette.blackSecondary,
    greenBackgroundOutlineAlternate: ptoColors.greenBlack,

    blueBackground: ptoColors.blue,
    blueBackgroundHover: ptoColors.blueLight,
    blueBackgroundSelected: ptoColors.blueDark,
    blueBackgroundOutline: palette.blackSecondary,
    blueBackgroundOutlineAlternate: ptoColors.blueBlack,

    tealBackground: ptoColors.teal,
    tealBackgroundHover: ptoColors.tealLight,
    tealBackgroundSelected: ptoColors.tealDark,
    tealBackgroundOutline: palette.blackSecondary,
    tealBackgroundOutlineAlternate: ptoColors.tealBlack,

    yellowBackground: ptoColors.yellow,
    yellowBackgroundHover: ptoColors.yellowLight,
    yellowBackgroundSelected: ptoColors.yellowDark,
    yellowBackgroundOutline: palette.blackSecondary,
    yellowBackgroundOutlineAlternate: ptoColors.yellowBlack,

    blackBackground: ptoColors.black,
    blackBackgroundOutline: palette.blackSecondary,

    enabledFragmentIndicator: palette.confirmAccent,
    disabledFragmentIndicator: palette.greyPrimary,

    /** Add RP Resource Cascading Menu */
    addRPResourceMenuItemHover: palette.blueAvailable,
    addRPResourceMenuRemovedCountBkg: palette.errorPrimary,
    addRPResourceMenuRemovedCountColor: palette.whitePrimary,
    addRPResourceMenuHeaderBkg: palette.greySecondary,
    addRPResourceMenuDividerColor: palette.grey,

    tooltipLightBackground: palette.whitePrimary,
    tooltipLightBoxShadow: changeOpacity(palette.blackPrimary, 0.4),

    /** Dash Builder Landing Page */
    dashBuilderHeaderBgColor: palette.daimlerPrimary,

    /** Loading Bar */
    loadingBarMeterColor: palette.blueAccent,
    loadingBarBgColor: palette.grey,

    /** Solenoid Locations */
    solenoidDropLocationCanDropBoarderColor: palette.blueAccent,
    solenoidDropLocationBoarderColor: palette.whitePrimary,
  }

  const fonts = {
    family: 'Arial',
    weight: 'normal',
    style: 'normal',
    stretch: 'normal',
  }

  const headers = {
    h1: {
      fontSize: '24px',
      lineHeight: '1.33',
      margin: '0',
    },
    h2: {
      fontSize: '20px',
      lineHeight: '1.2',
      margin: '0',
    },
    h3: {
      fontSize: '18px',
      lineHeight: '1.33',
      margin: '0',
    },
    h4: {
      fontSize: '14px',
      lineHeight: '1.33',
      margin: '0',
    },
  }

  const inputBorder = {
    radius: '3px',
    border: '1px solid',
  }

  // matches src/scss/_variables.scss (which could be imported directly here)
  const variables = {
    /* ChecActionDrawer and related */
    actionDrawerHeight: '52px',
  }

  return {
    color: palette,
    ...themeDefs,
    fonts,
    inputBorder,
    variables,
    dimensions,
    headers,
    ecuColors,
    ModalColors,
    ecpColletColors,
  }
}

export default setTheme
